var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    zoomAndPan: "magnify",
    viewBox: "0 0 768 767.999994",
    height: 1024,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 292.09375 392.628906 C 291.609375 393.109375 291.203125 393.664062 290.894531 394.265625 L 249.695312 473.230469 C 248.347656 475.816406 248.828125 478.96875 250.894531 481.042969 C 252.175781 482.316406 253.886719 483 255.621094 483 C 256.667969 483 257.738281 482.765625 258.722656 482.238281 L 337.71875 441.058594 C 338.320312 440.757812 338.863281 440.34375 339.355469 439.859375 L 350.40625 428.820312 L 303.140625 381.597656 Z M 292.09375 392.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 524.753906 207.347656 C 512.132812 194.714844 487.671875 197.140625 472.355469 212.464844 L 454.378906 230.421875 L 440.195312 216.25 C 438.945312 215 437.253906 214.292969 435.476562 214.292969 C 433.703125 214.292969 432.003906 214.988281 430.761719 216.25 L 350.394531 296.5625 C 347.785156 299.171875 347.785156 303.402344 350.394531 306.011719 C 351.699219 307.316406 353.410156 307.976562 355.121094 307.976562 C 356.832031 307.976562 358.542969 307.316406 359.839844 306.011719 L 435.457031 230.433594 L 444.921875 239.890625 L 312.5625 372.160156 L 359.828125 419.382812 L 492.199219 287.136719 C 494.808594 289.742188 497.800781 289.742188 500.421875 287.136719 C 503.042969 284.527344 499.183594 280.304688 499.183594 277.695312 L 499.183594 277.675781 L 518.378906 259.707031 C 534.261719 243.847656 537.792969 220.398438 524.753906 207.347656 Z M 524.753906 207.347656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposal);
export default __webpack_public_path__ + "static/media/proposal.da16f39288353cfb15c3eaeb03393850.svg";
export { ForwardRef as ReactComponent };